const AUTH_KEY = "heroscan_auth";

const VALID_USERS = [
  { email: "digvijay@scrobits.com", password: "Thinkpad@123" },
];

export function login(email, password) {
  const match = VALID_USERS.find(
    (u) => u.email === email.trim().toLowerCase() && u.password === password
  );
  if (!match) return false;
  localStorage.setItem(AUTH_KEY, JSON.stringify({ email: match.email, ts: Date.now() }));
  return true;
}

export function logout() {
  localStorage.removeItem(AUTH_KEY);
}

export function isAuthenticated() {
  try {
    const raw = localStorage.getItem(AUTH_KEY);
    return !!raw && !!JSON.parse(raw)?.email;
  } catch {
    return false;
  }
}

export function getAuthUser() {
  try {
    const raw = localStorage.getItem(AUTH_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
